import rests from "../_ApiConn/apiRests";


const getRests = async () => {

    let dFromF = await rests.getRests();
    return (dFromF);
}

const createRest = async (obj) => {
    let dFromF = await rests.createRest(obj);
    return (dFromF);
}

const getRestById = async (id) => {
    const token = localStorage.getItem('token');
    let dFromF = await rests.getRestById(id, { token });
    return (dFromF);
}

const updateRest = async (id, obj) => {
    const token = localStorage.getItem('token');
    let dFromF = await rests.updateRest(id, { ...obj, token });
    return (dFromF);
}
const deleteRest = async (id) => {
    let dFromF = await rests.deleteRest(id);
    return (dFromF);
}

const getClearRest = async () => {
    let dFromF = await rests.getClearRest();
    return (dFromF);
}


const getRestsListSmall = async () => {
    const token = localStorage.getItem('token');
    let dFromF = await rests.getRestsListSmall({ token });
    return (dFromF);
}

const updaterestStatus = async (restid, stat) => {
    
    const token = localStorage.getItem('token');
    let dFromF = await rests.updaterestStatus(restid, stat,token);
    return (dFromF);
}

const updaterestUrl = async (restid, stat) => {
    
    const token = localStorage.getItem('token');
    let dFromF = await rests.updaterestUrl(restid, stat,token);
    return (dFromF);
}




const updaterestCRType = async (restid, CRT) => {

    const token = localStorage.getItem('token');
    let dFromF = await rests.updaterestCRType(restid, CRT,token);
    return (dFromF);
}

export default {
    getRests,
    getRestById,
    updateRest,
    deleteRest,
    createRest,
    getClearRest,
    getRestsListSmall,
    updaterestStatus,
    updaterestCRType,
    updaterestUrl
    
};